import React from 'react'
import {MenuItem} from './MenuItem'

export function HeaderMenuInner() {
  return (
    <>
      <MenuItem title='About' to='/about' />
      <MenuItem title='Contact' to='/contact' />
    </>
  )
}
